import { installLanguage } from '@/i18n';
import '@/i18n/language.css';
import LanguageSwal from 'sweetalert2';
import StandaloneLanguageSwal from 'sweetalert2/dist/sweetalert2.js';
/**
=========================================================
* Vue Soft UI Dashboard - v3.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-soft-ui-dashboard
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { createApp } from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import SoftUIDashboard from "./soft-ui-dashboard";
import 'alertifyjs/build/css/alertify.min.css';
import 'alertifyjs/build/css/themes/default.min.css';

const appInstance = createApp(App);
installLanguage(appInstance, LanguageSwal, { portal: 'vendor', router });
if (StandaloneLanguageSwal !== LanguageSwal) installLanguage(appInstance, StandaloneLanguageSwal);
appInstance.use(store);
appInstance.use(router);
appInstance.use(SoftUIDashboard);
router.isReady().then(() => appInstance.mount("#app"));
